import { render, staticRenderFns } from "./viewProcess.vue?vue&type=template&id=36136c06&scoped=true&"
import script from "./viewProcess.vue?vue&type=script&lang=js&"
export * from "./viewProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36136c06",
  null
  
)

export default component.exports